import { Brand, createBranded } from '@deltasierra/type-utilities';

export type GoogleMyBusinessLocationResourceId = Brand<`${number}`, 'GoogleMyBusinessLocationResourceId'>;
export const GoogleMyBusinessLocationResourceId = createBranded<GoogleMyBusinessLocationResourceId>();
